import React, { useContext, useEffect, useState } from "react"
import { GetApi } from "../../../../api/api"
import { TreeView, TreeViewItem } from "@trimbleinc/modus-react-bootstrap"
import FeatureTypes from "./FeatureTypesComponent"
import { FeatureCatalogContext } from "../../FeatureCatalogProvider"
import featureTypeGroupIcon from "../../Assets/Icons/featureTypeGroup.svg"
import "./FeatureType.scss"
import { useHistory, useParams } from "react-router-dom"
import useQuery from "../UseQuery"

export interface IFeatureTypeGroup {
  name: string
  containsTypes: boolean | undefined
  pid: number
  no?: number | string
  description?: string
}

export interface FeatureTypeGroupsProps {
  id: string
}

const FeatureTypeGroups = () => {
  const [featureTypeGroups, setFeatureTypeGroups] = useState(new Array<IFeatureTypeGroup>())
  // Keep track of the "set" of expanded Feature Type Groups. A "set" is just an object:
  // If feature type groups 1, 2, 3 were expanded, then expanded would be:
  // { 1: true, 2: true, 3: true }
  const [expanded, setExpanded] = useState({} as { [key: number]: boolean })
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog } = useParams<{ catalog: string; type: string; pid: string }>()
  const language = useQuery().get("language")

  useEffect(() => {
    const getFeatureTypeGroup = async () => {
      GetApi().then((api) => {
        api.getAnyFeatureTypeGroups(catalog, language).then(async (response) => {
          const result = new Array<any>()
          response.map((featureTypeGroup) => {
            result.push({
              name: featureTypeGroup.name,
              containsTypes: featureTypeGroup.containsTypes,
              pid: featureTypeGroup.id,
              no: featureTypeGroup.no,
              description: featureTypeGroup.description,
              opened: false
            })
          })
          setFeatureTypeGroups(result)
        })
      })
    }

    getFeatureTypeGroup()
  }, [language])

  // Callback to TreeView whenever a node is expaded/collapsed
  const onNodeToggle = (event: React.SyntheticEvent, expandedPids: number[]) => {
    // Expanded is an array, convert to a "set"/object by using Object.fromEntries
    //                           the expanded pid becomes the key  `true` becomes the value
    //                                                         V     V
    setExpanded(Object.fromEntries(expandedPids.map((pid) => [pid, true])))
  }

  const onResize = () => {}
  const onResizeCapture = () => {}

  return (
    <div>
      <TreeView nodeId={0} id="basic" onNodeToggle={onNodeToggle} onResize={onResize} onResizeCapture={onResizeCapture}>
        {featureTypeGroups.map((featureTypeGroup) => {
          const onClick = (e: any) => {
            // if statement avoids panel updates when expanding a feature type group
            if (e.currentTarget === e.target) {
              context.setAtId(null)
              context.setTypeDisplayName(featureTypeGroup.name)
              context.updateHistory(history, catalog, "featureTypeGroup", "" + featureTypeGroup.pid)
            }
          }

          const label = (
            <div className="pr-3">
              <img src={featureTypeGroupIcon} />
              <span className="nameString">{featureTypeGroup.name} </span>
              <span className="badge badge-sm badge-text-secondary">{featureTypeGroup.pid}</span>
            </div>
          )

          return (
            <TreeViewItem
              nodeId={featureTypeGroup.pid}
              key={"ftg: " + featureTypeGroup.pid}
              label={label}
              className="card-text-2"
              onFocus={onClick}
            >
              {/*                            If this feature type group is expanded... */}
              {featureTypeGroup.containsTypes && featureTypeGroup.pid in expanded ? (
                // ...then load the component that fetches the feature types
                <FeatureTypes featureTypeGroup={featureTypeGroup} />
              ) : (
                // This will never be shown, but is here to make sure the expand icon is there in case
                // a feature type group contains types
                featureTypeGroup.containsTypes && "..loading"
              )}
            </TreeViewItem>
          )
        })}
      </TreeView>
    </div>
  )
}

export default FeatureTypeGroups
